function ClientError(status, title, message, extra) {
    this.stack = (new Error()).stack;
    this.status = status || 400;
    this.title = title || "Ooops!";
    this.message = message || "We're experiencing a problem. Please try again and if the problem persists, contact us at support@zeplin.io.";
    this.extra = extra;
}

ClientError.prototype = Object.create(Error.prototype);
ClientError.prototype.name = "ClientError";

ClientError.prototype.toString = function () {
    return "(" + this.status + ") " + this.title + "\n" + this.message;
};

export default ClientError;
